import { NON_GUEST } from "@excel-center/shared";
import { lazy } from "react";
import type { RouteObject } from "react-router";
import { ProtectedRoute } from "@/src/auth/components/protected-route";
import { MESSAGING_ROUTES } from "@/src/messaging/constants/messaging-routes.constants";

const MessagingPage = lazy(() => import("@/src/messaging/pages/messaging.page"));

export const messagingAuthedRoutes: RouteObject[] = [
	{
		path: MESSAGING_ROUTES.messaging,
		element: (
			<ProtectedRoute requiredRole={[...NON_GUEST]}>
				<MessagingPage />
			</ProtectedRoute>
		),
	},
];
